import {useEffect, useState} from "react";
import {BotaoSalvar, PaginaLogada, SelectFetch} from "../../componentes";
import {
  exibirMensagemErro,
  exibirMensagemSucesso,
  formatarDinheiro,
  formatarDinheiroParaDecimal,
  somenteNumeros,
  xfetch,
  HttpVerbo
} from "../../util";
import {useNavigate} from "react-router-dom";


export default function NovoProjeto() {

  const navegacao = useNavigate()
  const [isCarregando, setIsCarregando] = useState(false)
  const [obj, setObj] = useState({
    nome: '',
    valorDisponibilizado: '',
    valorContrapartida: '',
    dataInicio: '',
    dataLimite: '',
    fonte: -1,
    ano: '',
    numeroIgesp: '',
    contaBancaria: '',
    convenio: ''
  })


  function cadastrar(e) {
    e.preventDefault()
    let dados = {
      nome: obj.nome,
      idFonte: obj.fonte,
      dataInicio: obj.dataInicio,
      dataLimite: obj.dataLimite,
      valor: obj.valorDisponibilizado,
      ano: obj.ano,
      numeroIgesp: obj.numeroIgesp,
      idContaBancaria: obj.contaBancaria,
      convenio: obj.convenio,
      valorContrapartida: obj.valorContrapartida
    }

    if (isFundoaFundo) {
      dados.nome = dados.convenio
    }

    xfetch('/projeto', dados, HttpVerbo.POST)
      .then(res => res.json())
      .then(json => {
          exibirMensagemSucesso('Projeto criado com sucesso')
          navegacao('/projeto/' + json.id, {replace: true})
        }
      )
      .catch((e) => exibirMensagemErro("Erro ao cadastrar projeto - " + e) & console.log(e.error))
  }

  useEffect(() => {

  }, [])

  const isFundoaFundo = obj.fonte === '49'

  const titulo = obj.fonte === '49' ? "Fundo a Fundo" : "Novo Projeto"

  return (
    <PaginaLogada titulo={titulo} isCarregando={isCarregando}>
      <div className="card">
        <div className="card-body">
          <form>
            <div className="row">
              <div className="col-lg-8">
                <label className="col-form-label">Objeto:</label>
                <div className="col-lg-12">
                  <input
                    type="text"
                    onChange={(e) =>
                      setObj({...obj, nome: e.target.value.toString().toUpperCase()})}
                    value={obj.nome}
                    className="form-control"/>
                </div>
              </div>
              <div className="col-lg-4">
                <label className="col-lg-2 col-form-label">Fonte:</label>
                <div className="col-lg-12">
                  <SelectFetch setIsCarregando={setIsCarregando} handleChange={(e) => setObj({...obj, fonte: e.value})}
                               url='/fonteRecurso' placeholder='Selecione a fonte'/>
                </div>
              </div>
            </div>
            <div className={obj.fonte === '49' ? 'd-none' : 'row'}>
              <div className={"col-lg-2"}>
                <label className="col-form-label">Número IGESP:</label>
                <div className="col-lg-12">
                  <input type="text" className="form-control"
                         aria-label="Valor total"
                         value={obj.numeroIgesp}
                         onChange={(e) => setObj({...obj, numeroIgesp: e.target.value})}/>
                </div>
              </div>
              <div className="col-lg-2">
                <label className="col-form-label">Contrapartida:</label>
                <div className="col-lg-12 input-group">
                  <span className="input-group-text">R$</span>
                  <input type="text" className="form-control"
                         aria-label="Contrapartida"
                         value={formatarDinheiro(obj.valorContrapartida)}
                         onChange={(e) => setObj({
                           ...obj,
                           valorContrapartida: formatarDinheiroParaDecimal(e.target.value)
                         })}/>
                </div>
              </div>
              <div className="col-lg-3">
                <label className="col-form-label">Valor celebrado:</label>
                <div className="col-lg-12 input-group">
                  <span className="input-group-text">R$</span>
                  <input type="text" className="form-control"
                         aria-label="Valor total"
                         value={formatarDinheiro(obj.valorDisponibilizado)}
                         onChange={(e) => setObj({
                           ...obj,
                           valorDisponibilizado: formatarDinheiroParaDecimal(e.target.value)
                         })}/>
                </div>
              </div>
              <div className={"col-lg-5"}>
                <label className="col-form-label">Conta Bancária:</label>
                <div className="col-lg-12">
                  <SelectFetch setIsCarregando={setIsCarregando}
                     handleChange={(e) => setObj({...obj, contaBancaria: e.value})} url='/conta/select'
                     placeholder='Selecione a conta'/>
                </div>
              </div>
            </div>
            <div className="row mb-3">
              <div className={"col-lg-4"}>
                <label className="col-form-label">{obj.fonte === '49' ? 'Termo:' : 'Convênio:'}</label>
                <div className="col-lg-12">
                  <input type="text" className="form-control"
                         aria-label="Valor total"
                         value={obj.convenio}
                         onChange={(e) => setObj({...obj, convenio: e.target.value})}/>
                </div>
              </div>
              <div className="col-lg-2">
                <label className="col-form-label">Ano do projeto:</label>
                <div className="col-lg-12">
                  <input type="text" maxLength={4} value={obj.ano}
                         onChange={(e) => setObj({...obj, ano: somenteNumeros(e.target.value)})}
                         className="form-control"/>
                </div>
              </div>
              <div className="col-lg-2">
                <label className="col-form-label">Data Início Execução:</label>
                <div className="col-lg-12">
                  <input type="date"
                         onChange={(e) => setObj({...obj, dataInicio: e.target.value})}
                         className="form-control"/>
                </div>
              </div>
              <div className="col-lg-2">
                <label className="col-form-label">Data Limite Execução:</label>
                <div className="col-lg-12">
                  <input type="date"
                         onChange={(e) => setObj({...obj, dataLimite: e.target.value})}
                         className="form-control"/>
                </div>
              </div>
            </div>
            <div className={"row d-flex justify-content-center mt-5"}>
              <div className={"col-2 text-center d-grid gap-2"}>
                <BotaoSalvar onClick={cadastrar}/>
              </div>
            </div>
          </form>
        </div>
      </div>
    </PaginaLogada>
  );
}